import Axios from "axios";
import { APICommonFilter } from "../dtos/common";

function _baseUrl() {
    const host = window.location.hostname;
    if (host === 'online.foxitsoftware.cn' || host === 'app105967.eapps.dingtalkcloud.com') {
        return `https://dingtalk.foxitcloud.com`;
        // return `https://app105967.eapps.dingtalkcloud.com`;
    }
    return 'https://dingtalk-devazk8s.connectedpdf.com'
}
const BASE_URL = _baseUrl();
const DINGTALK_PATH = `/api`;
const COMMON_URL = `${BASE_URL}${DINGTALK_PATH}`;

const corpId = new URLSearchParams(location.search).get('corpId');
let token: string = null;

export default class DingtalkAPI {
    constructor() {
        throw new Error("Can not create instance!");
    }

    static get uri() {
        return COMMON_URL;
    }

    static get corpId() {
        if (!corpId) throw 'no cropId';
        return corpId;
    }

    static get axios() {
        return Axios;
    }

    static baseQuery(): APICommonFilter {
        return {
            ['access-token']: this.token,
            corp_id: this.corpId,
            al: 'zh-CN',
        }
    }

    static set token(accessToken: string) {
        token = accessToken;
    }

    static get token() {
        return token;
    }
}
